import axios from 'axios';

export default {
  list: (params = {}, config = {}) => axios.get('financial-accounts/conciliation', { params, ...config }),
  selectors: (params = {}, config = {}) => axios.get('financial-accounts/conciliation/selectors', { params, ...config }),
  saveReview: (payload = {}, config = {}) => axios.post('financial-accounts/conciliation/review', payload, config),
  deleteReview: (transactionId, config = {}) => axios.delete(`financial-accounts/conciliation/review/${transactionId}`, config),
};
